import { AttendeeRole } from "./schemas/enums/attendee-role";
import { AttendeeStatus } from "./schemas/enums/attendee-status";
import { AttendeeType } from "./schemas/enums/attendee-type";
import { CalendarChooserDisplayStyle } from "./schemas/enums/calendar-chooser-display-style";
import { CalendarPermissionScope } from "./schemas/enums/calendar-permission-scope";
import { CalendarSourceType } from "./schemas/enums/calendar-source-type";
import { CalendarType } from "./schemas/enums/calendar-type";
import { EventAvailability } from "./schemas/enums/event-availability";
import { EventSpan } from "./schemas/enums/event-span";
import { EventStatus } from "./schemas/enums/event-status";
import { RecurrenceFrequency } from "./schemas/enums/recurrence-frequency";
import { ReminderRecurrenceFrequency } from "./schemas/enums/reminder-recurrence-frequency";
import { registerPlugin } from "@capacitor/core";
const CapacitorCalendar = registerPlugin("CapacitorCalendar", {
    web: () => import("./web").then((m) => new m.CapacitorCalendarWeb()),
});
export * from "./definitions";
export { CalendarPermissionScope, EventAvailability, EventSpan, CalendarChooserDisplayStyle, CalendarType, CalendarSourceType, ReminderRecurrenceFrequency, RecurrenceFrequency, EventStatus, AttendeeRole, AttendeeType, AttendeeStatus, CapacitorCalendar, };
//# sourceMappingURL=index.js.map